import React from 'react';
import { oneOf } from 'prop-types';

import styles from './styles.module.scss';

export const SECTION_TITLE_TYPES = {
  TITLE: 'title',
  SUTITLE: 'subtitle'
};

function SectionTitle({ children, type }) {
  return <div className={styles[type]}>{children}</div>;
}

SectionTitle.defaultProps = {
  type: SECTION_TITLE_TYPES.TITLE
};

SectionTitle.propTypes = {
  type: oneOf(Object.values(SECTION_TITLE_TYPES))
};

export default SectionTitle;
